import React from 'react';
import PropTypes from 'prop-types';
import {
  StaticScreens,
  SlideDescription,
  AnimationWrapper,
  LottieAnimation,
} from '@learningblocks/storybook-components';
import './style.scss';

const TAB_KEY = 9;
const UP_ARROW = 38;
const DOWN_ARROW = 40;

export function FullPageScroll(props) {
  const descriptionList = props.sceneData.Scrolly.components;

  function handleScroll(event) {
    event.preventDefault();
    event.stopPropagation();
    const {keyCode, shiftKey} = event;
    if (props.scrolling === false && keyCode === TAB_KEY) {
      if (shiftKey) props.toPrevious();
      else props.toNext();
    }
    if (keyCode === UP_ARROW || keyCode === DOWN_ARROW) {
      document.activeElement.blur();
    }
  }

  const getAnimationOptions = () => ({
    loop: false,
    autoplay: false,
    animationData: props.animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });

  return (
    <div className='scrolly-full-page-scroll' onKeyUp={handleScroll}>
      <div className='animation full-height'>
        <StaticScreens scrollTip={props.scrollTip} />
        <SlideDescription
          descriptionList={descriptionList}
          scrollTip={props.scrollTip}
        />
        <AnimationWrapper hidden={props.scrollTip > 99.99}>
          <LottieAnimation
            value={props.value}
            options={getAnimationOptions()}
            scrollTip={props.scrollTip}
          />
        </AnimationWrapper>
      </div>
    </div>
  );
}

FullPageScroll.propTypes = {
  /**
   * Current value of scrollTip
   */
  scrollTip: PropTypes.number,
  /**
   * Boolean value specifying if page is scrolling
   */
  scrolling: PropTypes.bool,
  /**
   * The step value for scrolling
   */
  value: PropTypes.number,
};

FullPageScroll.defaultProps = {
  value: 4.5,
  scrolling: false,
};
